import React from 'react';
import { Box } from '@mui/material';

const Loading = ({width = "100px", height = "100px"}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: height, width: width }}>
      <Box
        sx={{
          width: '40px',
          height: '40px',
          border: '4px solid #e0e0e0',
          borderTop: '4px solid #2C7D89',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          '@keyframes spin': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(360deg)' }
          }
        }}
      />
    </Box>
  );
};

export default Loading;